import { createContext, useContext } from 'react';
import DEFAULT_STRINGS from '../constants/strings.en-US';
export var StringsContext = createContext(DEFAULT_STRINGS);
export function useStrings() {
    var strings = useContext(StringsContext);
    return strings;
}
